export default __webpack_public_path__ + "static/media/hello_man.115c586e.png";